import { Component, OnInit ,ViewChild} from '@angular/core';
import { PaymentSandbox } from '../../../../../../core/payment/payment.sandbox';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {LedgerService} from '../../../../../../core/ledger/ledger.service';

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss']
})
export class LedgerComponent implements OnInit {

  public filterForm: FormGroup;
  public filter = false;
  public miniDate: any;
  public dateError: string;
  public startDate: any;
  public isRequired = false;
  public endDate: any;
  @ViewChild(NgbDropdown)
  public dropdown: NgbDropdown;
  public keyword = '';
  public earningsArray = [];
  public filterData: any = [];
  public filterDataId = [];
  public selectedAll: any;
  public limit = 10;
  public offset = 0;
  public currentPage = 1;
  public userDetails = JSON.parse(sessionStorage.getItem('vendor-settings'));
  public currencyCode ;
  public queryData: any = {};

  // public Data 
  // = {"status":1,"message":"Successfully got the complete ledger list.","data":[{"createdBy":null,"createdDate":"2023-03-14T08:22:23.000Z","modifiedBy":null,"modifiedDate":"2023-03-14T08:22:23.000Z","id":555,"orderId":2136,"senderId":288,"receiverId":185,"source":"sales","amount":"15.18","ledgerType":"CR","balance":"1541.46","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"Arjun Singh","receiverName":"shahbaj khan","vendorOrderID":2050,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-14T07:55:57.000Z","modifiedBy":null,"modifiedDate":"2023-03-14T07:55:57.000Z","id":551,"orderId":2135,"senderId":356,"receiverId":185,"source":"sales","amount":"14.46","ledgerType":"CR","balance":"1526.28","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2049,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-14T07:54:54.000Z","modifiedBy":null,"modifiedDate":"2023-03-14T07:54:54.000Z","id":547,"orderId":2134,"senderId":356,"receiverId":185,"source":"sales","amount":"14.46","ledgerType":"CR","balance":"1511.82","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2048,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-14T07:53:57.000Z","modifiedBy":null,"modifiedDate":"2023-03-14T07:53:57.000Z","id":543,"orderId":2133,"senderId":356,"receiverId":185,"source":"sales","amount":"14.46","ledgerType":"CR","balance":"1497.36","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2047,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-14T12:22:40.000Z","modifiedBy":null,"modifiedDate":"2023-03-14T06:52:40.000Z","id":539,"orderId":2132,"senderId":356,"receiverId":185,"source":"sales","amount":"12.97","ledgerType":"CR","balance":"1482.90","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2046,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-13T13:37:51.000Z","modifiedBy":null,"modifiedDate":"2023-03-13T13:37:51.000Z","id":455,"orderId":2108,"senderId":356,"receiverId":185,"source":"sales","amount":"1382.09","ledgerType":"CR","balance":"1469.93","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2022,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-13T13:37:06.000Z","modifiedBy":null,"modifiedDate":"2023-03-13T13:37:06.000Z","id":451,"orderId":2107,"senderId":356,"receiverId":185,"source":"sales","amount":"13.16","ledgerType":"CR","balance":"87.84","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2021,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-13T13:36:14.000Z","modifiedBy":null,"modifiedDate":"2023-03-13T13:36:14.000Z","id":447,"orderId":2106,"senderId":356,"receiverId":185,"source":"sales","amount":"13.16","ledgerType":"CR","balance":"74.68","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2020,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-13T13:34:40.000Z","modifiedBy":null,"modifiedDate":"2023-03-13T13:34:40.000Z","id":443,"orderId":2105,"senderId":356,"receiverId":185,"source":"sales","amount":"22.04","ledgerType":"CR","balance":"61.52","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2019,"currencySymbolLeft":"$","currencySymbolRight":null},{"createdBy":null,"createdDate":"2023-03-13T13:33:36.000Z","modifiedBy":null,"modifiedDate":"2023-03-13T13:33:36.000Z","id":439,"orderId":2104,"senderId":356,"receiverId":185,"source":"sales","amount":"13.16","ledgerType":"CR","balance":"39.48","transactionType":"sale","transactionId":null,"balanceOwner":"seller","ownerId":185,"payoutStatus":null,"senderName":"jayant bhai a sharma","receiverName":"shahbaj khan","vendorOrderID":2018,"currencySymbolLeft":"$","currencySymbolRight":null}],"totalCount":12};
  public ledgerData 
  // = this.Data.data;
  public totalCount: any 
  // = this.Data.totalCount;
  


  constructor(public service : LedgerService, public paymentSandbox: PaymentSandbox, public formbuilder: FormBuilder, public router: Router, public route: ActivatedRoute,public titleService:Title) { }

  ngOnInit(): void {
    let params = {
      offset : this.offset,
      limit : this.limit,

    }
    this.ledgerlist()
  }
  ledgerlist() {
    let params = {
      offset : this.offset,
      limit : this.limit,

    }
    this.service.LedgerList(params).subscribe((data :any) => {
      if(data) {
        this.ledgerData = data.data;
        this.totalCount = data.totalCount;
        // this.ref.detectChanges();
      }
    });
  }
  /*View Order Page */
  vieworder(id) {
    this.router.navigate(['sales/manage-orders/view-orders'], { queryParams: { id } });
  }

  initFilterForm() {
    this.filterForm = this.formbuilder.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });
  }

  applyFilter() {
    if (
      (this.filterForm.controls['toDate'].value === '' ||
        this.filterForm.controls['toDate'].value === null) &&
      this.filterForm.controls['fromDate'].value !== '' &&
      this.filterForm.controls['fromDate'].value !== null
    ) {
      this.isRequired = true;
      return;
    }
    const form = this.filterForm.value.fromDate;
    const to = this.filterForm.value.toDate;
    this.filter = true;
    if (form && form.year) {
      this.startDate = form.year + '-' + form.month + '-' + form.day;
    }
    if (to && to.year) {
      this.endDate = to.year + '-' + to.month + '-' + to.day;
    }
    this.dropdown.close();
    this.getEarningsList();
  }

  onDateSelect(event) {
    event.stopPropogation();
    this.miniDate = event;
    this.dateError = '';
  }

  setMinValue(d) {
    this.isRequired = false;
    if (
      this.filterForm.controls['fromDate'].value === '' ||
      this.filterForm.controls['fromDate'].value === null
    ) {
      this.dateError = 'Choose From Date First';
      return;
    }
    d.toggle();
  }

  close() {
    this.dropdown.close();
  }

  resetFilter() {
    this.startDate = '';
    this.endDate = '';
    this.filter = false;
    this.filterForm.reset();
    this.getEarningsList();
  }

  getEarningsList() {
    // const params: any = {};
    // params.deliveryList = 1;
    // params.startDate = this.startDate ? this.startDate : '';
    // params.endDate = this.endDate ? this.endDate : '';
    // params.keyword = this.keyword;
    // params.limit = this.limit;
    // params.offset = this.offset;
    // this.paymentSandbox.getCategoryList(params);
  }

  exportEarnings() {
    if (this.filterDataId.length > 0) {
      const params: any = {};
      params.productId = this.filterDataId.toString();
      this.paymentSandbox.multipleEarningExport(params);
      this.paymentSandbox.categoryListLoaded$.subscribe(data => {
        if (data === true) {
          this.paymentSandbox.removeExportSelection('earning');
          this.selectedAll = false;
          this.filterDataId = [];
        }
      });
    } else {
      const params: any = {};
      const vendor = JSON.parse(sessionStorage.getItem('vendorUserDetails'));
      params.vendorId = vendor.vendorId;
      this.paymentSandbox.exportEarning(params);
    }
  }

  search(val) {
    this.keyword = val;
    this.getEarningsList();
    this.getTotalEarningsCount();
  }

  selectAll() {
    for (let i = 0; i < this.earningsArray.length; i++) {
      this.earningsArray[i].selected = this.selectedAll;
    }
    this.filterDataList();
  }

  checkIfAllSelected() {
    this.selectedAll = this.earningsArray.every(function (item: any) {
      return item.selected === true;
    });
    this.filterDataList();
  }

  filterDataList() {
    this.filterData = this.earningsArray.filter(data => {
      if (data.selected === true) {
        return data;
      }
    });
    this.filterDataId = this.filterData.map(obj => obj.productId);
  }

  getTotalEarningsCount() {
    const params: any = {};
    params.deliveryList = 1;
    params.startDate = this.startDate ? this.startDate : '';
    params.endDate = this.endDate ? this.endDate : '';
    params.keyword = this.keyword;
    params.limit = this.limit;
    params.offset = this.offset;
    params.count = 1;
    this.paymentSandbox.getEarningListCount(params);
    this.queryData.offset = this.offset || 0;
    this.queryData.index = this.currentPage || 1;
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.queryData,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });

  }

  pageChange(event) {
    this.currentPage = event;
    this.offset = this.limit * (event - 1);
    this.ledgerlist();
  }

}
